<template>
  <v-dialog v-model="isOpen" max-width="350" lazy persistent>
    <v-card>
      <div class="pa-2">
        <v-card-title class="headline">{{ title }}</v-card-title>
        <v-card-text>{{ body }}</v-card-text>
      </div>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="primary"
          flat
          @click.native="closeConfirmDialog(false)">
          {{ cancelText }}
        </v-btn>
        <v-btn
          color="primary"
          flat
          @click.native="closeConfirmDialog(true)">
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'ConfirmDialog',

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    title: String,
    body: String,
    cancelText: String,
    confirmText: String,
  },

  methods: {
    ...mapMutations({
      closeConfirmDialog: 'ui/closeConfirmDialog',
    }),
  },
};
</script>
